import type { AvailableOnSide } from "@tosize/shapes/src/types/finish";
import type { Workpiece } from "../../../lib/workpiece";

const DIAMETERID = "diameter_";

type HolesType = {
	position: number;
	offset_x: number | null;
	offset_y: number | null;
	diameter: number | null;
	depth: number | null;
};

interface WorkPieceDrillholesProps {
	workpiece: Workpiece;
	side: AvailableOnSide;
}

export function getWorkPieceDrillholes({ workpiece, side }: WorkPieceDrillholesProps) {
	const sides = Object.entries(workpiece.finishes.side).filter(([key]) => key === side.sideCode);
	const finishes = sides
		.flatMap(([_, value]) => Object.values(value).flat())
		.filter((finish) => finish.option.startsWith(DIAMETERID));

	const workPieceHoles = finishes.map((finish, index) => ({
		position: index,
		offset_x: Number(finish.option_parameters.offset_x) / 10,
		offset_y: Number(finish.option_parameters.offset_y) / 10,
		diameter: Number(finish.option.replace(DIAMETERID, "")),
		depth: Number(finish.option_parameters.depth),
	})) as HolesType[];

	return workPieceHoles;
}
